/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Chart_Series_HrInputs */

const en_ui_chart_series_hr = /** @type {(inputs: Ui_Chart_Series_HrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HR (bpm)`)
};

const de_ui_chart_series_hr = /** @type {(inputs: Ui_Chart_Series_HrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HF (bpm)`)
};

/**
* | output |
* | --- |
* | "HR (bpm)" |
*
* @param {Ui_Chart_Series_HrInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_chart_series_hr = /** @type {((inputs?: Ui_Chart_Series_HrInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Chart_Series_HrInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_chart_series_hr(inputs)
	return de_ui_chart_series_hr(inputs)
});